const baseURL = process.env.REACT_APP_API as string; 
export const urlShort = baseURL + '/queryShort'
export const urlLong = baseURL + '/orchestrators/queryLongCsv'
export const urlParquet = baseURL + '/orchestrators/queryLongParquet'
export const urlMetaData = baseURL + '/queryStationMetaData'

export const apiScope = process.env.REACT_APP_API_SCOPE + '/user_impersonation' || ''